"use client"

import { useState } from "react"
import { PayPalButtons, usePayPalScriptReducer } from "@paypal/react-paypal-js"
import PaypalWrapper from "@modules/checkout/components/payment-wrapper/paypal-wrapper"
import ErrorMessage from "@modules/checkout/components/error-message"
import { isPaypalConfigured } from "@lib/constants"

// Renders the real PayPal Buttons SDK widget (same one used for checkout and
// the product-page express button) so it looks pixel-identical to PayPal's
// own button everywhere it appears in the app. There is no "Log In with
// PayPal" Medusa auth provider yet (only Google is wired up via
// /api/auth/google), so onClick rejects before the SDK opens its popup and
// shows a notice instead of starting a payment flow that doesn't apply here.
const PaypalAuthButtonInner = () => {
  const [{ isPending }] = usePayPalScriptReducer()
  const [showNotice, setShowNotice] = useState(false)

  if (isPending) {
    return <div className="w-full h-12 rounded-full bg-[#ffc439]/30 animate-pulse" />
  }

  return (
    <div style={{ position: "relative", isolation: "isolate" }}>
      <PayPalButtons
        style={{
          layout: "horizontal",
          color: "gold",
          shape: "pill",
          label: "paypal",
          tagline: false,
          height: 48,
        }}
        onClick={(_data, actions) => {
          setShowNotice(true)
          return actions.reject()
        }}
        createOrder={async () => {
          throw new Error("PayPal sign-in is not available yet")
        }}
      />
      {showNotice && (
        <ErrorMessage
          error="PayPal sign-in isn't available yet — please use email or Google."
          data-testid="paypal-auth-notice"
          className="mt-3 flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm font-medium text-amber-800"
        />
      )}
    </div>
  )
}

const PaypalAuthButton = () => {
  if (!isPaypalConfigured()) {
    return null
  }

  return (
    <PaypalWrapper>
      <PaypalAuthButtonInner />
    </PaypalWrapper>
  )
}

export default PaypalAuthButton
